import React from 'react';
import { styled } from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';

const Container = styled('section')({
  display: 'flex',
  flexDirection: 'column',
});

const InfoContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '30px',
});

const Subtitle5 = styled('h5')({
  fontSize: '12px',
  fontWeight: '500',
  color: 'var(--color-light)',
});

const Title = styled('h1')({
  fontSize: '30px',
  color: 'var(--color-primary)',
});

const Cards = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  '@media (max-width: 1020px)': {
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const Card = styled('div')({
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  margin: '20px',
  borderRadius: '0px 0px 10px 10px',
  backgroundColor: 'var(--color-bg-variant)',
  border: '1px solid var(--color-primary)',
  gap: '10px',
  width: '33.3333333%',
  transition: 'all 1s ease',
  '&:hover': {
    backgroundColor: '#1f1f38',
    transform: 'scale(1.02)',
  },
  '@media (max-width: 1020px)': {
    width: '80%',
  },
});

const CardTitleContainer = styled('span')({
  borderRadius: '0px 0px 10px 10px',
  width: 'calc(100% - 40px)',
  height: '30px',
  position: 'absolute',
  padding: '20px',
  backgroundColor: 'var(--color-primary)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const Subtitle3 = styled('h3')({
  fontSize: '18px',
  fontWeight: '700',
  color: 'var(--color-bg)',
});

const CardContentContainer = styled('span')({
  padding: '70px 20px 20px 20px',
});

const ServicesList = styled('ul')({});

const Service = styled('li')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  margin: '15px 0',
});

const Content = styled('p')({
  fontSize: '16px',
  fontWeight: '600',
});

function Services() {
  return (
    <Container id="services">
      <InfoContainer>
        <Subtitle5>What I offer</Subtitle5>
        <Title>Services</Title>
      </InfoContainer>
      <Cards>
        {/* Web & Software Development */}
        <Card>
          <CardTitleContainer>
            <Subtitle3>Web & Software Development</Subtitle3>
          </CardTitleContainer>
          <CardContentContainer>
            <ServicesList>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Design and development of corporate, e-commerce, and custom websites.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Creation of responsive and user-friendly interfaces with HTML, CSS, JavaScript, and ReactJS.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Custom software solutions for web or desktop applications tailored to client requirements.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Integration of third-party APIs and payment gateways for seamless functionality.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Business process automation to improve efficiency and reduce manual tasks.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Website optimization for SEO and performance improvements.</Content>
              </Service>
            </ServicesList>
          </CardContentContainer>
        </Card>

        {/* Data & Machine Learning */}
        <Card>
          <CardTitleContainer>
            <Subtitle3>Data & Machine Learning</Subtitle3>
          </CardTitleContainer>
          <CardContentContainer>
            <ServicesList>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Exploration, visualization, and interpretation of complex datasets.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Development of predictive and classification machine learning models.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Deployment of AI models and end-to-end machine learning pipelines.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Data storytelling and interactive dashboards for actionable insights.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Automation of data processing and workflow optimization.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Integration with cloud platforms (AWS, GCP, Azure) for scalable solutions.</Content>
              </Service>
            </ServicesList>
          </CardContentContainer>
        </Card>

        {/* Consulting & Training */}
        <Card>
          <CardTitleContainer>
            <Subtitle3>Consulting & Training</Subtitle3>
          </CardTitleContainer>
          <CardContentContainer>
            <ServicesList>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Digital transformation consulting for businesses of all sizes.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Advice on technology selection, architecture design, and software best practices.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Professional training in web development, data analysis, and machine learning.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Workshops on automation, AI adoption, and cloud computing.</Content>
              </Service>
              <Service>
                <CheckIcon style={{ color: 'var(--color-primary)' }} />
                <Content>Hands-on support and mentoring for startups and professionals.</Content>
              </Service>
            </ServicesList>
          </CardContentContainer>
        </Card>
      </Cards>
    </Container>
  );
}

export default Services;
